import { FC, useContext } from "react";

import { useAtomValue } from "jotai";

import { currentStepAtom } from "./atoms/currentStep.atom";

import { Step1 } from "./components/Step1";
import { Step2 } from "./components/Step2";

import { Form } from "@components/Form/Form";
import { FormProvider } from "@components/FormProvider/FormProvider";

import { IIVolunteeringFormData } from "./VolunteeringFormRoute.types";

import FORM_DETAILS from "@jsons/FORM_DETAILS.json";
import { AuthContext } from "@components/AuthProvider/contexts/Auth.context";

export const VolunteeringFormRoute: FC = () => {
  const {
    authUser: { uid },
  } = useContext(AuthContext)!;

  const currentStep = useAtomValue(currentStepAtom);

  return (
    <FormProvider<IIVolunteeringFormData> uid={uid} formName="volunteering">
      {({
        user,
        draft,
        isSaving,
        isSubmitted,
        isSavePending,
        onSubmit,
        onSaveChanges,
      }) => (
        <Form
          totalSteps={2}
          isSaving={isSaving}
          currentStep={currentStep}
          title={FORM_DETAILS.Volunteering.title}
          description={FORM_DETAILS.Volunteering.description}
        >
          {currentStep === 1 && (
            <Step1
              user={user}
              draft={draft}
              isSavePending={isSavePending}
              onChange={onSaveChanges}
            />
          )}
          {currentStep === 2 && (
            <Step2
              draft={draft}
              isSubmitted={isSubmitted}
              isSavePending={isSavePending}
              onSubmit={onSubmit}
              onChange={onSaveChanges}
            />
          )}
        </Form>
      )}
    </FormProvider>
  );
};
